<template>
  <div v-if="$tools.isEmpty(chat)" class="text-center mt-10">
    <alert>Чат не выбран</alert>
  </div>
  <div v-else>
    <v-toolbar dense flat>
      <v-btn icon @click="$emit('close')" class="mr-2"><v-icon>mdi-close</v-icon></v-btn>
      <div class="d-flex align-center" :style="'width: calc(100% - '+(chat?.type==='process' ? '130' : '84')+'px)'">
        <div class="text-no-wrap mr-2">
          <div class="body-1">{{chat.info.userClient.fullName}}</div>
          <div class="body-2 mt-n1 caption">
            <span>{{chat.info.typeStr}}</span>
            <dot/>
            <call-phone :phone="chat.info.userClient.phone" small/>
            <span v-if="searchClientState.data.items.filter(v=>v.id===chat.info.userClient.userId).length>0">
              <dot/>
              <span>{{searchClientState.data.items.filter(v=>v.id===chat.info.userClient.userId)[0].userProfile.gender==='male' ? 'мужчина' : 'женщина'}}</span><dot/>
              <span>{{$tools.dateYearsSimple(searchClientState.data.items.filter(v=>v.id===chat.info.userClient.userId)[0].userProfile.birth, 'YYYY-MM-DD HH:mm:ss')}}</span>
              </span>
          </div>
        </div>
      </div>
      <v-spacer/>
      <div class="overflow-y-auto text-no-wrap full-width text-right">
        <v-btn
            :disabled="$tools.isEmpty(chat.info.userClient.userId)"
            @click="$tools.openUrl('/panel/user/'+chat.info.userClient.userType+'/'+chat.info.userClient.userId+'/', true)"
            depressed small class="ml-2"
        >
          Профиль<v-icon dense small class="ml-2">mdi-open-in-new</v-icon>
        </v-btn>
        <v-menu offset-y max-width="300" z-index="10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs" v-on="on"
                :loading="searchClientState.loading"
                :disabled="searchClientState.data.items.length<=1"
                class="ml-2" depressed
                small
            >
              <v-icon small class="mr-2">mdi-account-edit</v-icon>
              Клиенты {{searchClientState.data.items.length>1 ? '('+searchClientState.data.items.length+')' : ''}}
            </v-btn>
          </template>
          <v-list v-if="searchClientState.data.items.length>1" dense class="pa-0">
            <v-list-item
                v-for="(v, i) in searchClientState.data.items" :key="i"
                class="pa-0"
                :class="chat.info.userClient.userId===v.id ? 'v-list-item--active' : ''"
            >
              <v-row no-gutters>
                <v-col cols="12" class="py-2 px-4">
                  <div class="body-2">{{$tools.userFullName(v, true)}}</div>
                  <div class="body-2 caption">
                    <span>{{v.userProfile.gender==='male' ? 'мужчина' : 'женщина'}}</span><dot/>
                    <span>{{$tools.dateYearsSimple(v.userProfile.birth, 'YYYY-MM-DD HH:mm:ss')}}</span>
                  </div>
                </v-col>
                <v-col class="pb-2 px-4">
                  <v-btn
                      @click="chat.info.userClient.userId===v.id ? null : changeClient(v)"
                      :disabled="chat.info.userClient.userId===v.id"
                      depressed small class="mr-2"
                  >
                    {{chat.info.userClient.userId===v.id ? 'Выбран' : 'Выбрать'}}
                  </v-btn>
                  <v-btn @click="$tools.openUrl('/panel/user/'+v.type+'/'+v.id+'/', true)" depressed small>
                    Профиль<v-icon dense small class="ml-2">mdi-open-in-new</v-icon>
                  </v-btn>
                </v-col>
                <v-col v-if="i<searchClientState.data.items.length-1" cols="12">
                  <v-divider/>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu v-if="filterView.id==='all' && chat.type!=='queue'" v-model="changeOperatorOpen" offset-y min-width="350" max-width="350" z-index="10" :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="ml-2" depressed small>
              <v-icon small class="mr-2">mdi-account-tie</v-icon>
              {{$tools.userFullName(chat.userOperator, true)}}
            </v-btn>
          </template>
          <div class="px-4 py-2">
            <div class="caption mb-3">Сменить оператора</div>
            <user-autocomplete-single ref="changeOperatorAutocomplete" @update:select="(v)=>userOperator=v" class="mb-0" name="Администраторы" _type="admin"/>
            <v-btn @click="changeOperator()" depressed small class="mt-2">Сменить</v-btn>
          </div>
        </v-menu>
        <btn-depressed-small-icon-accept
            v-if="chat?.type==='process'"
            icon="mdi-account-remove"
            name="Закрыть"
            button-class="ml-2"
            text="Вы уверены что хотите закрыть обращение. Чат будет перемещен в список закрытых"
            @accept="closeType()"
        />
      </div>
      <template v-slot:extension>
        <div v-if="chat.info.userClient?.userId">
          <tag-add :entityId="chat.info.userClient?.userId" entityType="user" sideTitle/>
        </div>
      </template>
    </v-toolbar>
    <v-divider/>
    <v-progress-linear
        v-if="messagesState.loading"
        class="position-absolute"
        indeterminate
        background-color="transparent"
    />
    <v-sheet
        ref="messages"
        :min-height="heightCalc"
        :max-height="heightCalc"
        class="overflow-y-auto pt-2"
    >
      <div v-for="v in messagesState.data.items" :key="messagesStateKey+$tools.key(v)">
        <message
            :message="v"
            class="message"
            :data-id="v.id"
            :data-readed="$tools.isEmpty(v.readed) ? '' : $tools.dateTime(v.readed)"
            :data-user-id="v.info.user.userId"
        />
      </div>
    </v-sheet>

    <div class="position-relative" style="z-index: 10">
      <v-row v-if="chat.type==='queue' || chat.type==='closed'" no-gutters>
        <v-col cols="12">
          <v-divider/>
        </v-col>
        <v-col cols="12">
          <v-btn
              @click="$emit('toClient', chat)"
              style="border-radius: 0"
              depressed small block
              height="47"
          >
            В обработку
            {{$tools.isEmpty(chat.closed) ? '' : '(закрыт '+$tools.userFullName(chat.userOperator, true)+' в '+$tools.dateTimeFormat(chat.closed, 'DD.MM.YYYY HH:mm')+')'}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-else no-gutters>
        <v-col cols="12">
          <v-divider/>
        </v-col>
        <v-col cols="auto" class="pt-1 pl-2">
          <com-contact-select
              ref="comContactSelect"
              :chat="chat"
              @update:comContactSelected="(v)=>comContactSelected=v"
          />
        </v-col>
        <v-col>
          <div id="helps" class="position-relative"></div>
          <v-menu v-model="helpsOpen" ref="helps" attach="#helps" top max-height="400">
            <v-list dense class="pa-0">
              <v-list-item
                  v-for="(item, i) in helps"
                  @click="messageTemplateSelect(messageTemplatesComponent.selectTemplateSelect(item))"
                  :key="i"
                  class="pa-0"
              >
                <div class="full-width">
                  <div class="py-2 px-4">
                    <div class="body-2" v-html="$tools.nl2br($tools.textHighlight(item.text, messText))"></div>
                  </div>
                  <v-divider/>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-textarea
              v-model="messText"
              ref="messText"
              solo flat auto-grow rows="1" hide-details
              :placeholder="comContactSelected?.allowSend===false ? 'Воспользуйтесь шаблоном для отправки сообщения...' : 'Введите сообщения...'"
              :readonly="comContactSelected?.allowSend===false"
              @keyup="templateId = null"
              @keydown.enter.exact.prevent="messageSend"
              @keydown.enter.ctrl.prevent="messText+='\n'"
          >
            <template v-slot:prepend>
              <v-icon v-if="comContactSelected?.allowSend===false" class="ml-2 mr-n2" size="20">mdi-lock</v-icon>
            </template>
          </v-textarea>
        </v-col>
        <v-col v-if="!$tools.isEmpty(messText)" cols="auto" class="pt-1 pr-2">
          <v-btn icon @click="messText=null;messTextTags=[];templateId=null"><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
        <v-col cols="auto" class="pt-1 pr-2">
          <v-btn @click="attach=true;mediaPaths=[]" :disabled="comContactSelected?.allowSend===false" icon>
            <v-icon>mdi-paperclip</v-icon>
            <v-badge v-if="mediaPaths.length>0" :content="mediaPaths.length"/>
          </v-btn>
          <uploader
              :dialog.sync="attach"
              :multiple="true"
              url="/napi/file/"
              @uploadComplete="(v)=>mediaPaths=v"
          />
        </v-col>
        <v-col cols="auto" class="pt-1 pr-1">
          <v-btn icon @click="messageSend" :loading="messageSendState.loadingUpdate"><v-icon>mdi-send</v-icon></v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  Entity_Chat, Entity_ComContact,
  Entity_Message, Entity_User, Entity_UserProfile
} from "../../../../../EntityStoreCacheService";
import Stater from "../../../../plugins/stater";
import Message from "./Message.vue";
import axios from "axios";
import Api from "../../../../Api";
import moment from "moment";
import ComContactSelect from "./ComContactSelect.vue";
import Dot from "../../../../componentsV2/base/Dot.vue";
import TagAdd from "@/views/Tag/components/TagAdd.vue";
import Uploader from "@/components/Uploader.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import BtnDepressedSmallIconAccept from "@/componentsV2/base/BtnDepressedSmallIconAccept.vue";
import UserAutocompleteSingle from "@/componentsV2/custom/UserAutocompleteSingle.vue";
import CallPhone from "@/components/CallPhone.vue";

export default {
  components: {
    CallPhone,
    UserAutocompleteSingle,
    BtnDepressedSmallIconAccept, Alert, Uploader, TagAdd, Dot, ComContactSelect, Message},
  props: ['height','chat','messageTemplates','messageTemplatesComponent','filterView'],
  data: () => ({
    users:[],
    heightCalc:0,
    messText:null,
    messTextTags:[],
    templateId:null,
    messagesState:new Stater({items:[],count:0}),
    messagesStateKey:null,
    messageSendState:new Stater(),
    helps:[],
    helpsOpen:false,
    attach: false,
    mediaPaths: [],
    tagsState: new Stater({items:[],count:0}),

    comContactSelected:null,

    subscribeListenerId:null,
    lastInputTime:null,
    messageReadTimer:null,
    messageReadObserver:null,
    messageReadIds:[],
    messageReadState:new Stater(),
    page:1,
    searchClientState: new Stater(),
    changeOperatorOpen:false,
    userOperator:null,
  }),
  mounted(){
    this.heightResize();
    this.helpsCompute();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v)=>this.subscribeListenerId=v, (m)=>{
      if(m.type==='messengerMessage' && this.chat!==null && m.data.chat.id===this.chat.id){
        m.data.new = true;
        if(this.messagesState.data.items.filter(v=>v.id===m.data.id).length===0)
        this.messagesState.data.items.push(m.data);
        this.scrollBottom();
        if(this.$tools.isDefined(this.$refs.comContactSelect))
          this.$refs.comContactSelect.comContactRequest(m.data.comContact, true)
      }
      if(m.type==='messengerMessageReaded' && this.chat!==null && m.data.chat.id===this.chat.id){
        this.messagesState.data.items
            .filter(v=>v.id===m.data.id)
            .forEach(v=>v.readed = m.data.readed)
      }
      if(m.type==='messengerMessageReaction' && this.chat!==null && m.data.chat.id===this.chat.id){
        this.messagesState.data.items
            .filter(v=>v.id===m.data.id)
            .forEach(v=>v.reaction = m.data.reaction)
      }
      if(m.type==='messengerMessageErrored' && this.chat!==null && m.data.chat.id===this.chat.id){
        this.messagesState.data.items
            .filter(v=>v.id===m.data.id)
            .forEach(v=>{
              v.errored = m.data.errored
              v.error = m.data.error
            });
      }
      this.messagesStateKey = this.$tools.key(this.messagesState)
    });

    this.messageReadObserver = new IntersectionObserver((entries)=>{
      entries
          .filter(v=>v.isIntersecting)
          .filter(v=>parseInt(v.target.getAttribute('data-user-id'))!==this.$store.state.user?.id)
          .filter(v=>this.$tools.isEmpty(v.target.getAttribute('data-readed')))
          .forEach(v => {
            let id = parseInt(v.target.getAttribute('data-id'));
            if(!this.messageReadIds.includes(id))
              this.messageReadIds.push(id);
            this.messageReadObserver.unobserve(v.target)
          })
    }, {
      root: null,
      threshold: 1
    });
    this.messageReadTimer = setInterval(()=>{
      if(this.chat?.type!=='process')
        return;
      document.querySelectorAll('.message').forEach(v=>this.messageReadObserver.observe(v))
      if(this.messageReadIds.length===0)
        return;
      if(this.messageReadState.loading)
        return;
      this.messageReadState.stateLoading()
      let messageReadIds = this.$tools.copy(this.messageReadIds);
      axios.post(Api.host+'/messenger/chat/message/readed/', messageReadIds)
          .then(()=>{
            messageReadIds.forEach(v1=>{
              this.messageReadIds = this.messageReadIds.filter(v=>v!==v1)
            })
            this.messageReadState.stateSuccess()
          });
    }, 1000);
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
    clearInterval(this.messageReadTimer);
  },
  watch:{
    chat(){
      if(this.chat===null){
        this.$refs.messages.$el.removeEventListener('scroll',this.scrollMessagesHandler);
      } else {
        this.$nextTick(()=>{
          this.$refs.messages.$el.addEventListener('scroll',this.scrollMessagesHandler);
        })
      }
      this.heightResize();
      this.chatMessagesLoad();
      this.searchClient();
      this.messagesState.data = {count:0,items:[]}
      this.messText = null;
      this.messTextTags = [];
      this.templateId = null;
    },
    height(){
      this.heightResize();
    },
    comContactSelected: {
      deep: true,
      handler() {
        this.$emit('update:comContact', this.comContactSelected)
      },
    },
    messText(){
      this.heightResize();
      this.lastInputTime = moment();
      this.helpsCompute();
    },
    changeOperatorOpen(){
      if(this.changeOperatorOpen){
        this.$nextTick(()=>{
          this.$refs.changeOperatorAutocomplete.open()
        })
      }
    }
  },
  methods:{
    heightResize(){
      this.$tools.debounce(()=>{
        this.$nextTick(()=>{
          this.heightCalc = this.height-48-48-1;
          if(!this.$tools.isEmpty(this.chat)){
            if(this.chat.type==='queue' || this.chat.type==='closed')
              this.heightCalc -= 48;
            else
              this.heightCalc -= this.$refs.messText.$el.getBoundingClientRect().height+1
          }
        })
      }, 100, 'chatHeightResize');
    },
    chatMessagesLoad(page=1){
      if(this.chat===null)
        return;
      new Entity_Message()
          .selects(Entity_Message.id)
          .selects(Entity_Message.text)
          .selects(Entity_Message.mediaPath)
          .selects(Entity_Message.created)
          .selects(Entity_Message.readed)
          .selects(Entity_Message.errored)
          .selects(Entity_Message.error)
          .selects(Entity_Message.reaction)
          .selects([Entity_Message.comContact, Entity_ComContact.id].join('.'))
          .virtual(Entity_Message.virtual_info)
          .order(Entity_Message.created, false)
          .page(page)
          .onPage(20)
          .filterAnd([Entity_Message.entity, Entity_Message.chat, Entity_Chat.id].join('.')+'=?',this.chat.id)
          .addStateCallback((v)=>{
            this.messagesState.setRequestBuilderState(v, false, true)
            let items = this.messagesState.data.items;
            items = items.sort((a,b)=>{
              let a1 = moment(a.created, 'YYYY-MM-DD HH:mm:ss').unix()
              let b1 = moment(b.created, 'YYYY-MM-DD HH:mm:ss').unix()
              if(a1===b1) return 0;
              return a1>b1 ? 1 : -1;
            })
            this.messagesState.data.items = items;
            if(page===1){
              if(v.count>0)
                this.scrollBottom();
              if(v.success && items.length>0 && this.$tools.isDefined(this.$refs.comContactSelect)){
                this.$refs.comContactSelect.comContactRequest(items[items.length-1].comContact)
              }

            }
          })
          .request()
    },
    scrollBottom(){
      this.$tools.debounce(()=>{
        this.$refs.messages.$el.scrollTop = this.messagesState.data.count * 1000;
      }, 100, 'chatScroll');
    },
    scrollMessagesHandler(){
      if(this.$refs.messages.$el.scrollTop<600 && this.messagesState.data.count>this.messagesState.data.items.length){
        this.$tools.debounce(()=>{
          this.chatMessagesLoad(++this.page);
        }, 100, 'scrollMessagesHandler_'+this.type)
      }
    },
    messageSend(){
      if(this.messageSendState.loadingUpdate)
        return;
      if(this.$tools.isEmpty(this.messText) && this.mediaPaths.length===0 && this.templateId===null)
        return;

      this.messageSendState.stateLoadingUpdate()
      axios.post(Api.host+'/messenger/chat/'+this.chat.id+'/message/', {
        comContactId:this.$refs.comContactSelect.comContact?.id,
        text:this.messText,
        textTags:this.messTextTags,
        templateId:this.templateId,
        mediaPaths:this.mediaPaths,
      }).then(()=>{
        this.messText = '';
        this.messTextTags = [];
        this.templateId = null;
        this.mediaPaths = [];
        this.scrollBottom();
        this.messageSendState.stateSuccess()
      }).catch(()=>{
        this.messText = '';
        this.messTextTags = [];
        this.templateId = null;
        this.mediaPaths = [];
        this.scrollBottom();
        this.messageSendState.stateSuccess()
      });
    },
    closeType(){
      axios.post(Api.host+'/messenger/chat/'+this.chat.id+'/close/')
        .then(()=>{
          this.$emit('close')
        });
    },
    messageTemplateSelect(v){
      if(!this.$tools.isDefined(v))
        return;
      this.messText = v.textResult;
      this.messTextTags = this.$tools.isEmpty(v.textTags) ? [] : v.textTags;
      this.templateId = v.id;
    },
    helpsCompute(){
      if(this.$tools.isBlank(this.messText)) {
        this.helps = [];
        this.helpsOpen = false;
      } else {
        this.helps = this.messageTemplates.filter(v=>v.text.toLowerCase().includes(this.messText.toLowerCase()))
        if(this.helps.length===1 && this.helps[0].text===this.messText)
          this.helpsOpen = false;
        else
          this.helpsOpen = true;
      }
      if(this.$tools.isDefined(this.$refs.helps))
        this.$refs.helps.updateDimensions();
    },
    changeClient(v){
      axios.put(Api.host+'/messenger/chat/'+this.chat.id+'/', {
        userClientId:v.id
      })
    },
    changeOperator(){
      axios.put(Api.host+'/messenger/chat/'+this.chat.id+'/', {
        userOperatorId:this.userOperator?.id
      }).then(()=>{
        this.changeOperatorOpen = false
      })
    },
    searchClient(){
      if(this.chat===null)
        return;
      new Entity_User()
          .selects(Entity_User.id)
          .selects(Entity_User.firstName)
          .selects(Entity_User.lastName)
          .selects(Entity_User.secondName)
          .selects(Entity_User.type)
          .selects([Entity_User.userProfile, Entity_UserProfile.gender].join('.'))
          .selects([Entity_User.userProfile, Entity_UserProfile.birth].join('.'))
          .order([Entity_User.userProfile, Entity_UserProfile.birth].join('.'), true)
          .addStateCallback(v=>{
            this.searchClientState.setRequestBuilderState(v)
          })
          .filterOr([Entity_User.entity, Entity_User.id].join('.')+'=?', this.chat.info.userClient.userId)
          .filterOr(
              [Entity_User.entity, Entity_User.phone].join('.') + '=? OR ' +
              [Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.phone1].join('.') + '=?',
              this.chat.info.userClient.phone,
              this.chat.info.userClient.phone
          )
          .request()
    }
  }
}
</script>